import { authenticatedFastApiAxiosInstance } from "@/lib/data/http";
import { type APIResponse, type ContactConnection } from "@/lib/types";
import { baseContactRoute } from "./contact";

export const createContactConnectionV1 = (
  data: Pick<
    ContactConnection,
    "sourceContactId" | "targetContactId" | "relationshipType"
  > &
    Partial<Pick<ContactConnection, "description">>,
) => {
  return authenticatedFastApiAxiosInstance
    .post<
      APIResponse<ContactConnection>
    >(`${baseContactRoute}/connections`, data)
    .then((res) => res.data);
};

export const deleteContactConnectionV1 = (data: { id: string }) => {
  return authenticatedFastApiAxiosInstance
    .delete<
      APIResponse<ContactConnection>
    >(`${baseContactRoute}/connections/${data.id}`)
    .then((res) => res.data);
};
